import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorLocationSubdistrict = () => {
  const listSubdistrict = useCallback((callback, payload, loadingCallback) => {
    payload = {
      district_uid: payload,
    }
    ApiService.jsonRequest('/master-subdistrict/list', payload, (response) => {
      if (response.status_code === 200) {
        callback(response.data)
      }
      loadingCallback(false)
    })
  }, [])

  return { listSubdistrict }
}

export default InteractorLocationSubdistrict
